import React from "react";

// Logo ZAVIA apilado: icono grande, nombre debajo y eslogan debajo del nombre.
export default function Logo({ variant = "dark", className = "" }) {
  const color = variant === "light" ? "#FFFFFF" : "#0B1F44";
  const sub = variant === "light" ? "#C9D6F0" : "#5B6B85";
  return (
    <div className={`inline-flex flex-col items-center text-center ${className}`} data-testid="brand-logo">
      <img src="/zavia-icon.png" alt="ZAVIA" className="w-16 h-14 sm:w-20 sm:h-16 object-contain" />
      <div className="font-display font-extrabold tracking-[0.08em] text-xl sm:text-2xl leading-none mt-1" style={{ color }}>ZAVIA</div>
      <div className="font-display text-[10px] sm:text-[11px] tracking-wide whitespace-nowrap mt-1" style={{ color: sub }}>Tu colegio, en un solo lugar</div>
    </div>
  );
}
